<template>
<!-- 三大服务-近视 -->
    <div class="content">
        <div class="eye">
            <img class="pic" src="../assets/icon_touxiang 31@2x.png" alt="pic">
            <div class="title">眼科医学专家</div>
            <div class="container">
                <!-- 邵立功  -->
                <p>眼科学与视觉发育科学博士、儿眼科学与眼视光医学博士后、美国休斯顿大学视光科学院小儿视觉发育学与眼科学客座教授、首儿李桥儿童医院儿眼科专家会诊中心、主任医师、中国优生优育协会眼病防治技术专业委员会主任委员、中国优生优育协会专家委员、中国优生优育协会常务理事、全国儿童青少年斜视弱视近视眼保健指导中心主任委员、中国眼视光学杂志常务编委、“中国优生优育协会眼病防治技术专业委员会北京海润阳光文化中心眼保健、视觉功能测试图书和视觉认知发育以及视觉艺术培养学习图书研发生产基地”专家顾问。</p>
            
                <div>个人简历</div>
                
                <p>1978-1983年毕业于哈尔滨医科大学医疗系五年制本科获学士学位；</p>
                <p>1988-1991年在第四军医大学神经眼科学与眼肌屈光专业获硕士学位；</p>
                <p>1994-1997年在北京大学医学部儿童视觉发育研究中心和北京大学医学部第一临床医学院妇儿医院斜视弱视与小儿眼科专业毕业获医学博士学位；</p>
                <p>1997-1998年应邀在美国休斯顿大学视光科学院合作从事儿视觉发育科学,视觉发育异常早期干预及近视和弱视发病机理的博士后研究，并被聘为美国休斯顿大学视光科学院小儿视觉发育学与眼科学客座教授；</p>
                <p>1999-2001年，在解放军总医院全军眼科与神经内科研究中心从事复合性神经营养因子辅助视神经修复再生的后续博士后研究，申请并完成了中国博士后基金1项，全军医药卫生科研基金2项和国家自然科学基金3项获突出成绩和科研成果。</p>
                <p>2001-2012年，北京近视防控与斜弱视矫治专家会诊指导中心主任，主任医师、教授,研究生导师；全国儿童青少年近视防控斜弱视矫治眼保健指导中心主任，中国优生优育协会眼病防治技术专业委员会主任；中国优生优育协会常务理事和专家委员；中国初级卫生保健基金会近视防控专业委员会付主任和专家委员，中华育婴协会眼科专业委员会主任，北京保护健康协会眼与脑保健专业委员会主任，北京首都儿科研究所李桥儿童医院儿眼科特诊和眼肌手术专家；中国优生优育杂志常务编委；中国眼视光学杂志常务编委；中华医药学杂志常务编委；国际斜弱视学会理事；国际电生理学会理事；国家自然科学基金委员会视觉发育学与斜弱视和近视研究领域重点项目评审专家；中国人民解放军卫生音像出版社特聘专家；北京市学生眼保健操修订专家组副主任委员；中国网易，凤凰和搜狐母婴亲子网在线专家；中国摇篮网在线专家、妈妈宝典网在线专家、加加堂网在线专家和中央电视台少儿频道、小宝贝大学堂、节目组，北京电视台和北京广播电台及爱家广播等特聘专家等。</p>
            </div>
            
        </div>
        <div class="QRcodeBox">
            <!-- <div class="QRcode"></div> -->
            <img class="QRcode" src="../assets/erweima@2x.png">
        </div>

        <div class="card">
            <div>扫码进群</div>
            <div>仅限500人</div>
            <div>开放时间：周三上午9:00~11:00</div>

            <div>
                上次讨论纪要：1.....
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {

    },
    data() {
        return {

        };
    },
    computed: {

    },
    created() {

    },
    mounted() {

    },
    watch: {

    },
    methods: {

    },
    components: {

    },
};
</script>

<style scoped>
.content {
    padding: 28px;
}
.eye {
    padding: 28px;
    background: #fff;
    border-radius: 25px;
}
.eye .pic {
    width: 150px;
    height: 150px;
    /* background: #c34a45; */
    border-radius: 50%;
    display: block;
    margin: 0 auto 40px;
}
.eye .title {
    text-align: center;
    letter-spacing: 4px;
    margin-bottom: 30px;
}
.eye p {
    line-height: 52px;
    text-indent: 35px;
}
.QRcodeBox {
    width: 252px;
    height: 252px;
    background: #fff;
    margin: 28px auto;
    padding: 28px;
    border-radius: 25px;
}

.QRcode {
    width: 100%;
    height: 100%;
    /* background: #c34a45; */
}

.card {
    padding: 28px;
    background: #fff;
    text-align: center;
    margin-bottom: 26px;
}

.card div{
    margin-bottom: 26px;
}

.card div:nth-of-type(2) {
    font-size: 34px;
    color: #c34a45;
}

.card div:last-of-type {
    text-align: left;
}
.container {
    height: 460px;
    padding: 0 20px;
    /* border: 2px dashed #c34a45; */
    border-radius: 10px;
    overflow-y: scroll;
}
</style>


// WEBPACK FOOTER //
// src/views/Eye.vue